import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import ClientShipCard from "./ClientShipCard";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import MMPLShipCard from "./MMPLShipCard";
import DatePicker from "react-datepicker";
import axios from "axios";
import API from "../helpers/api";
import Moment from "moment";
import { getMDSearchlist } from "../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import { getClientShipCount, getClientShipDetails } from "../Actions/ClientDashboardAPI"
import { getContractCount, getContractDeatil, getContractHistory, getContractSearchlist, getContractStatusOptions } from "../Actions/ContractMgmtAPI";
import AddIcon from "../UIComponents/AddIcon";
import { getshipNameList } from "../Actions/UserManageAPI";
import { toast } from "react-toastify";
import $ from "jquery";
import Role from "../helpers/role";
import { use } from "react";

const SearchItem = {
  contractNumber: "",
  ShipName: "",
  ImoNo: "",
  clientName: "",
  startdate: "",
  expiryDate: "",
  minyear: "",
  maxyear: "",
  contractStatusId: 7,
  PageSize: 25,
  PageNumber: 1,
  overDue: false,
  dueIn30Days: false,
};

class ContractManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDate: "",
      TotalContracts: 100,
      OverDue: 90,
      DueIn30Days: 100,
      toDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "All Ships",
      clientList: [],
      searchDate: {
        contractNumber: "",
        ShipName: "",
        ImoNo: "",
        clientName: "",
        startdate: "",
        expiryDate: "",
        minyear: "",
        maxyear: "",
        contractStatusId: 7,
        PageSize: 25,
        PageNumber: 1,
        overDue: false,
        dueIn30Days: false,
      },
    };
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.SearchMDData = this.SearchMDData.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onChangeClientName = this.onChangeClientName.bind(this);
  }


  componentDidMount() {
    const { dispatch, match, t } = this.props;
    dispatch(getContractStatusOptions())
    
    this.getClientList();
    if (this.props.contractSearch) {
      this.state.searchDate = this.props.contractSearch;
      dispatch(getContractSearchlist(this.state.searchDate));
      dispatch(getContractCount(this.state.searchDate.contractStatusId));
    }
    else {
      dispatch(getContractSearchlist(this.state.searchDate));
      dispatch(getContractCount(this.state.searchDate.contractStatusId));
    }
    dispatch({ type: 'SubBannerTitle', data: "Contract Management" });
    let searchitem = this.state.searchDate;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if ( this.verifySearchItems())
      //   // searchitem.contractNumber ||
      //   // searchitem.ShipName ||
      //   // searchitem.ImoNo ||
      //   // searchitem.clientName ||
      //   // searchitem.status ||
      //   // searchitem.startdate ||
      //   // searchitem.expiryDate
      //   {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.props.dispatch(getContractCount(_this.state.searchDate.contractStatusId));
          _this.SearchMDData(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }


  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchDate = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchDate = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchDate));
    }
  }

  getShipDetails(action) {

    if (action === "noAction") {
      this.state.filterTitle = "All Ships";
      this.state.searchDate.serviceStatus = "noAction";
      this.state.searchDate.overDue = false;
      this.state.searchDate.dueIn30Days = false;
    } else if (action === "expired") {
      this.state.filterTitle = "Expired Ships";
      this.state.searchDate.serviceStatus = "expired";
      this.state.searchDate.overDue = false;
      this.state.searchDate.dueIn30Days = true;
    } else {
      this.state.filterTitle = "Expiring Ships";
      this.state.searchDate.serviceStatus = "expiring";
      this.state.searchDate.overDue = true;
      this.state.searchDate.dueIn30Days = false;
    }
    this.state.searchDate.contractStatusId = 7;
    this.props.dispatch(getContractCount(7));
    this.setState({ showClientDetails: false, filterclientDetails: false });
    this.SearchMDData(1);
  }

  getClientDetails() {
    this.setState({ showClientDetails: true, filterShiplist: false });
  }

  SearchMDData(pgno) {

    this.state.searchDate["PageNumber"] = pgno;
    const { dispatch } = this.props;
    this.setState({ filterShiplist: true })
    dispatch({ type: "contractSearch", data: this.state.searchDate });
    dispatch(getContractSearchlist(this.state.searchDate));
  }
  verifySearchItems = () => {
    let flag = true;
    const search = this.state.searchDate;
    if (search.contractNumber == "" && search.ShipName == "" && search.ImoNo == "" && search.clientName == "" && search.contractStatusId == 0 && search.startdate == "" && search.expiryDate == "") {
      flag = false;
    }
    return flag;
  }

  getContractSearch(pgno) {
    const { dispatch, t } = this.props;
    if (this.verifySearchItems()) {
      this.setState({ filterclientDetails: true })
      this.state.searchDate["PageNumber"] = pgno;
      dispatch(getContractCount(this.state.searchDate.contractStatusId));
      dispatch({ type: "contractSearch", data: this.state.searchDate });
      dispatch(getContractSearchlist(this.state.searchDate));
    }
    else {
      toast.success(`${t("Toast.Success")}`, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  ClearSearchField() {
    const { dispatch } = this.props;
    SearchItem.overDue = this.state.searchDate.overDue;
    SearchItem.dueIn30Days = this.state.searchDate.dueIn30Days;
    let param = { ...SearchItem };
    this.setState({
      searchDate: param,
    });
    dispatch(getContractCount(7));
    dispatch({ type: "contractSearch", data: "" });
    dispatch(getContractSearchlist(param));
  }

  handleFromDateChange(date) {
    this.state.searchDate.startdate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.searchDate.expiryDate = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleRadioButtonChanges(e) {
    let nodeName = e.target.name;
    this.state.searchDate["status"] = nodeName
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    if (nodeName === "contractStatusId") {
      this.state.searchDate[nodeName] = parseInt(e.target.value);
    } else {
      this.state.searchDate[nodeName] = e.target.value;
    }
    this.setState({});
  }

  NewitemNav = () => {
    let obj = {
      "clientName": "",
      "imo": ""
    }
    this.props.dispatch({ type: "getClientIMONOSuccess", data: obj })
    this.props.history.push("/Home/AddContract");
  };
  onChangeClientName = (event, value) => {
    this.setState({
      searchDate: {
        ...this.state.searchDate,
        clientName: value,
      },
    });
  };
  getClientList = () => {
    let url = `${API.Clientlist}`;
    axios
      .get(url)
      .then((response) => {
        this.state.clientList = response.data.clients;
        this.setState({})
      })
      .catch((error) => {
        console.log(error);
      });
  };


  render() {
    let user = localStorage.getItem("UserRoles");
    const { showSidePane, arraylist, ClientShipDetails, showContractDetailsPane, contractCount, contractDetail, contractSearchResult, t } = this.props;
    const { showClientDetails, showshiplist, searchDate } = this.state;
    return (
      <div className="full-height pt-3">
        <div className="row">
          <div className="col-lg-4">
            <div className={`${!searchDate.overDue && !searchDate.dueIn30Days ? "active " : ""}card card-selector text-center my-1`} onClick={() => this.getShipDetails("noAction")} >
              <h1>{contractCount.total}</h1>
              <h5>{t("ShipEquipmentStatusScreen.Total")}</h5>
            </div>
          </div>
          <div className="col-lg-4">
            <div className={`${searchDate.overDue ? "active " : ""}card card-selector text-center my-1`} onClick={() => this.getShipDetails("expiring")} >
              <h1 style={{ color: 'rgb(255,0,0)' }}>{contractCount.overDue}</h1>
              <h5 className="text-center">{t("ShipEquipmentStatusScreen.Overdue")}</h5>
            </div>
          </div>
          <div className="col-lg-4">
            <div className={`${searchDate.dueIn30Days ? "active " : ""}card card-selector text-center my-1`} onClick={() => this.getShipDetails("expired")} >
              <h1 style={{ color: 'rgb(255,130,90)' }}>{contractCount.in30Days}</h1>
              <h5 className="text-center">{t("ShipEquipmentStatusScreen.Due30")}</h5>
            </div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col-lg-12">
            <div className="panel-box">
              <div className="card MM-card-header mb-0" style={{ backgroundColor: "white", border: "0px" }} >
                <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1a3464", color: "white" }}>
                  <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                    {t("ContractManagementContent.Title")}
                  </h5>
                  {user === Role.mmpladmin &&
                    <div className="m-1 flex" onClick={this.NewitemNav}>
                      <span className="mt-1"> {t("ContractManagementContent.AddContract")}</span><AddIcon />
                    </div>
                  }
                </div>
              </div>
              <div className="search-filter-box">
                <div className="row">
                  <div className={showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "}>
                    <label className="form-label">{t("ContractContent.ContractNumber")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="contractNumber"
                      placeholder={t("ContractContent.ContractNumber")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.contractNumber}
                    ></input>
                  </div>
                  <div className={showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "}>
                    <label className="form-label">{t("content.Shipname")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="ShipName"
                      placeholder={t("content.Shipname")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.ShipName}
                    ></input>
                  </div>
                  <div className={showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "}>
                    <label className="form-label">{t("ContractManagementContent.IMONumber")}</label>
                    <br></br>
                    <input
                      className="form-control"
                      type="text"
                      name="ImoNo"
                      placeholder={t("ContractManagementContent.IMONumber")}
                      onChange={(e) => this.handleInputChange(e)}
                      value={this.state.searchDate.ImoNo}
                    ></input>
                  </div>
                  <div className={showContractDetailsPane ? "col-lg-6 " : "col-lg-4 "}>
                    <label className="form-label">{t("ContractManagementContent.ClientName")}</label>
                    <br></br>
                    <Autocomplete
                      id="clientnameplaceholder"
                      value={this.state.searchDate.clientName}
                      options={this.state.clientList}
                      getOptionLabel={(option) => option || ""}
                      onChange={(event, value) => {
                        this.onChangeClientName(event, value);
                      }}
                      noOptionsText={"No options to display"}
                      freeSolo={false}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className="form-control clientnameplaceholder"
                          id="clientnameplaceholder"
                          style={{ marginTop: -1 }}
                          margin="dense"
                          size="small"
                          variant="outlined"
                          placeholder={t("ContractManagementContent.ClientName")}
                        />
                      )}
                    />
                  </div>
                  <div className={showContractDetailsPane ? "col-lg-6 " : "col-lg-4 wd"}>
                    <label className="form-label">{t("EquipmentServiceTypes.Status")}</label>
                    <br></br>
                    <div className={showContractDetailsPane ? "row" : "row pl-3"}>
                      <select
                        className={`form-control text-capitalize mr-3 ${showContractDetailsPane ? "ml-3" : ""}`}
                        name="contractStatusId"
                        value={this.state.searchDate.contractStatusId}
                        onChange={(e) => this.handleInputChange(e)}>
                        <option value="">{t("ContractManagementContent.SelectStatus")}</option>
                        {this.props.contractStatus?.map((item, ind) => (
                          item.lookUpName &&
                          <option className="text-capitalize" value={item.lookUpId}>{item.lookUpName}</option>
                        ))}
                        {/* <option value="active">Active</option>
                            <option value="pending">Pending</option>
                            <option value="terminated">Terminated</option> */}
                      </select>
                      {/* <div className={showContractDetailsPane ? "col-sm-4 clsm-3" : " mt-2 mr-5"} >
                        <input
                          type="radio"
                          name="active"
                          checked={this.state.searchDate.status === "active"}
                          ref="check_me"
                          onChange={this.handleRadioButtonChanges.bind(this)}
                        ></input>
                        <span className="ml-1">Active</span>
                      </div> */}
                      {/* <div className={showContractDetailsPane ? "col-sm-4 clsm-3" : " mt-2 mr-5"} >
                        <input
                          type="radio"
                          name="pending"
                          checked={this.state.searchDate.status === "pending"}
                          onChange={this.handleRadioButtonChanges.bind(this)}
                        ></input>
                        <span className="ml-1">Pending</span>
                      </div>
                      <div className={showContractDetailsPane ? "col-sm-6 clsm-9" : " mt-2 "} >
                        <input
                          type="radio"
                          name="terminated"
                          checked={this.state.searchDate.status === "terminated"}
                          onChange={this.handleRadioButtonChanges.bind(this)}
                        ></input>
                        <span className="ml-1">Terminated</span>
                      </div> */}
                    </div>
                  </div>

                  <div
                    className={
                      showContractDetailsPane
                        ? "col-lg-12  col-sm-12 col-xs-12"
                        : "col-lg-4  col-sm-12 col-xs-12"
                    }>
                    <div className="row">
                      <div className={showContractDetailsPane ? "col-lg-6" : "col-lg-6"}>
                        <label className="form-label">{t("ContractManagementContent.StartDate")}</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd"  >
                          <input
                            type="text"
                            value={this.state.searchDate.startdate}
                            className="form-control date-picker"
                            placeholder={t("ContractManagementContent.StartDate")}
                            name="fromDate" ></input>
                          <DatePicker
                            selected={this.state.SelectedFromDate}
                            onChange={this.handleFromDateChange}
                            open={this.state.fromDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control date-picker w-5 hide-date" />
                          <div
                            className="input-group-btn calendar-icon"
                            onClick={this.openFromDatePicker} >
                            <button className="btn btn-default">
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className={showContractDetailsPane ? "col-lg-6" : "col-lg-6"}>
                        <label className="form-label">{t("ContractManagementContent.ExpiryDate")}</label>
                        <div
                          className="input-group add-on date datepicker"
                          data-date-format="yyyy-mm-dd" >
                          <input
                            value={this.state.searchDate.expiryDate}
                            type="text"
                            placeholder={t("ContractManagementContent.ExpiryDate")}
                            className="form-control date-picker"
                            name="toDate"
                            data-date-format="yyyy-mm-dd"
                          />
                          <DatePicker
                            selected={this.state.SelectedToDate}
                            onChange={this.handleToDateChange}
                            open={this.state.toDatePickerIsOpen}
                            onClickOutside={this.handleBlur}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            popperPlacement="top-end"
                            className="form-control date-picker w-5 hide-date" />
                          <div className="input-group-btn calendar-icon">
                            <button
                              className="btn btn-default"
                              onClick={this.openToDatePicker}>
                              <i className="fa fa-calendar mt-1"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className={"col-lg-12"}>
                    <div className="search-btn-col my-3" style={{ textAlign: "end" }} >
                      <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.getContractSearch(1)} >
                        {t("content.Search")}
                      </button>
                      <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.ClearSearchField()}>
                        {t("content.Clear")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {contractSearchResult ? (
          <ClientShipCard
            arraylist={contractSearchResult.data}
            currentPage={(contractSearchResult.pagination.currentPage - 1) * contractSearchResult.pagination.pageSize}
            pageSize={contractSearchResult.pagination.pageSize}
            totalRecords={contractSearchResult.pagination.totalcount ? contractSearchResult.pagination.totalcount : 0}
            setUpdatedState={(value) => this.SearchMDData(value)}
            eyeclick={(item) => this.eyeclick(item)}
          />
        ) : null}

      </div>
    );
  }

  eyeclick(item) {
    const { dispatch } = this.props;
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push(`/Home/Contracts/${item.contractId}`);
  }

  MDNewitemNav = () => {
    this.props.dispatch({ type: "MD Library", data: false });
    this.props.history.push("/Home/MDNewItem");
  };
}

function mapStateToProps(state) {

  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    materialDeclarationslist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    showContractDetailsPane: state.SidePanReducer.ShowContractDetailsPane || false,
    //BY BALU MOORTHI
    contractCount: state.ContractMgmtReducer.ContractCount || {
      "total": 0, "overDue": 0, "in30Days": 0
    },
    // contractDetail: state.ContractMgmtReducer.ContractDetail || {},
    contractSearchResult: state.ContractMgmtReducer.ContractSearchResult,
    contractSearch: state.ContractMgmtReducer.contractSearch,
    contractClientName: state.ContractMgmtReducer.ContractClientName || {},
    contractStatus: state.ContractMgmtReducer.contractStatus
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps)(ContractManagement));
